export { default as localizeDevextreme } from "./localizeDevextreme";
export { default as locale } from "./localizeDevextreme.locale";
